import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './jwt.interceptor';
import { ErrorInterceptor } from './error.interceptor';

export const httpInterceptorProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor,multi:true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
];
